import { Box, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { QueryField } from '../../../../../types/QueryBuilder';
import { useLanguage } from '../../../../../context/LanguageContext';
import { COUNTER_FIELD_NAME, resolveFieldLabel } from './fieldConfig';

function FieldLabel({ field }: { field: QueryField }) {
    const { t } = useLanguage();
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
                {resolveFieldLabel(field, t)}
            </Typography>
            {field.name === COUNTER_FIELD_NAME && (
                <Tooltip title={t('pages.clients.queryBuilder.simple.customerAccount.tooltip')} arrow>
                    <InfoOutlinedIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
                </Tooltip>
            )}
        </Box>
    );
}

export default FieldLabel;
